/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddLssGroup200Response } from './AddLssGroup200Response';
import {
    AddLssGroup200ResponseFromJSON,
    AddLssGroup200ResponseFromJSONTyped,
    AddLssGroup200ResponseToJSON,
} from './AddLssGroup200Response';
import type { StationAton } from './StationAton';
import {
    StationAtonFromJSON,
    StationAtonFromJSONTyped,
    StationAtonToJSON,
} from './StationAton';
import type { StationPositionWatchdog } from './StationPositionWatchdog';
import {
    StationPositionWatchdogFromJSON,
    StationPositionWatchdogFromJSONTyped,
    StationPositionWatchdogToJSON,
} from './StationPositionWatchdog';

/**
 * 
 * @export
 * @interface Station
 */
export interface Station {
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    aisIndicator?: number;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    aisTimeout?: string;
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    aisType21?: number;
    /**
     * 
     * @type {any}
     * @memberof Station
     */
    aisType21Cfg?: any | null;
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    aisType6?: number;
    /**
     * 
     * @type {any}
     * @memberof Station
     */
    aisType6Cfg?: any | null;
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    aisType8?: number;
    /**
     * 
     * @type {any}
     * @memberof Station
     */
    aisType8Cfg?: any | null;
    /**
     * 
     * @type {StationAton}
     * @memberof Station
     */
    aton?: StationAton;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    mmsi?: number;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    name?: string;
    /**
     * 
     * @type {any}
     * @memberof Station
     */
    offPosition?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Station
     */
    position?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Station
     */
    positionAccuracy?: any | null;
    /**
     * 
     * @type {StationPositionWatchdog}
     * @memberof Station
     */
    positionWatchdog?: StationPositionWatchdog;
    /**
     * 
     * @type {any}
     * @memberof Station
     */
    pssUuid?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Station
     */
    rtu?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Station
     */
    sigfox?: any | null;
    /**
     * 
     * @type {AddLssGroup200Response}
     * @memberof Station
     */
    stationHealth?: AddLssGroup200Response;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    uuid?: string;
}

/**
 * Check if a given object implements the Station interface.
 */
export function instanceOfStation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StationFromJSON(json: any): Station {
    return StationFromJSONTyped(json, false);
}

export function StationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Station {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aisIndicator': !exists(json, 'ais_indicator') ? undefined : json['ais_indicator'],
        'aisTimeout': !exists(json, 'ais_timeout') ? undefined : json['ais_timeout'],
        'aisType21': !exists(json, 'ais_type_21') ? undefined : json['ais_type_21'],
        'aisType21Cfg': !exists(json, 'ais_type_21_cfg') ? undefined : json['ais_type_21_cfg'],
        'aisType6': !exists(json, 'ais_type_6') ? undefined : json['ais_type_6'],
        'aisType6Cfg': !exists(json, 'ais_type_6_cfg') ? undefined : json['ais_type_6_cfg'],
        'aisType8': !exists(json, 'ais_type_8') ? undefined : json['ais_type_8'],
        'aisType8Cfg': !exists(json, 'ais_type_8_cfg') ? undefined : json['ais_type_8_cfg'],
        'aton': !exists(json, 'aton') ? undefined : StationAtonFromJSON(json['aton']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'offPosition': !exists(json, 'off_position') ? undefined : json['off_position'],
        'position': !exists(json, 'position') ? undefined : json['position'],
        'positionAccuracy': !exists(json, 'position_accuracy') ? undefined : json['position_accuracy'],
        'positionWatchdog': !exists(json, 'position_watchdog') ? undefined : StationPositionWatchdogFromJSON(json['position_watchdog']),
        'pssUuid': !exists(json, 'pss_uuid') ? undefined : json['pss_uuid'],
        'rtu': !exists(json, 'rtu') ? undefined : json['rtu'],
        'sigfox': !exists(json, 'sigfox') ? undefined : json['sigfox'],
        'stationHealth': !exists(json, 'station_health') ? undefined : AddLssGroup200ResponseFromJSON(json['station_health']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
    };
}

export function StationToJSON(value?: Station | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ais_indicator': value.aisIndicator,
        'ais_timeout': value.aisTimeout,
        'ais_type_21': value.aisType21,
        'ais_type_21_cfg': value.aisType21Cfg,
        'ais_type_6': value.aisType6,
        'ais_type_6_cfg': value.aisType6Cfg,
        'ais_type_8': value.aisType8,
        'ais_type_8_cfg': value.aisType8Cfg,
        'aton': StationAtonToJSON(value.aton),
        'description': value.description,
        'mmsi': value.mmsi,
        'name': value.name,
        'off_position': value.offPosition,
        'position': value.position,
        'position_accuracy': value.positionAccuracy,
        'position_watchdog': StationPositionWatchdogToJSON(value.positionWatchdog),
        'pss_uuid': value.pssUuid,
        'rtu': value.rtu,
        'sigfox': value.sigfox,
        'station_health': AddLssGroup200ResponseToJSON(value.stationHealth),
        'type': value.type,
        'uuid': value.uuid,
    };
}

